var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pv6"},[_c('h2',{staticClass:"f1 serif tracked ttu tc normal ma0"},[_vm._v("Loading preview...")])])}]

export { render, staticRenderFns }